// src/components/cards/Card.jsx
import React from "react";

function Card({ item, theme, setSelectedInfo, setSelectedRank, onHide }) {
  const avgScore = (item.relianceScore + item.variantsScore + item.usabilityScore) / 3;
  try { item.avgScore.toFixed(2); } catch (e) { /* ignore */ }  

  const imageSrc =
    item.customHTML && item.customHTML.trim() !== ""
      ? item.customHTML 
      : item.cardHTML || item.cardhtml;

  return (
    <div
      className="card-snap"
      style={{
        boxShadow: "0 0 10px rgba(77, 76, 75, 0.2)",
        border: "1px solid rgba(255, 215, 0, 0.3)",
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.05), rgba(255,255,255,0.02))",
        borderRadius: "12px",
        padding: "12px",
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
      }}
    >
      <img
        src={imageSrc}
        alt={item.cardName}
        style={{
          width: "100%",
          borderRadius: "8px",
          boxShadow: "0 0 6px rgba(255, 215, 0, 0.15)",
        }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "8px",
          fontSize: "0.9rem",
          color: "rgb(197,176,55)",
        }}
      >
        <span className="rank-value">{avgScore > -1 ? avgScore.toFixed(2) : ""}</span>
      </div>
      <div
        className="card-actions"
        style={{ marginTop: "8px", display: "flex", gap: "8px" }}
      >
        <button className="button" onClick={() => setSelectedInfo(item)}>
          Info
        </button>
        {onHide !== undefined && (
          <>
            <button className="button" onClick={() => setSelectedRank(item)}>
              Update
            </button>
            <button className="button" onClick={() => onHide(item)}>
              Hide
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Card;
